const customTLFreeGiftOverride = function () {
    if (!window || !window.Shopify) return;

    const CartEvents = {
        add: "TLFREEGIFT:add",
        update: "TLFREEGIFT:update",
        change: "TLFREEGIFT:change",
        clear: "TLFREEGIFT:clear",
        mutate: "TLFREEGIFT:mutate",
    };

    const ShopifyCartURLs = [
        "/cart/add",
        "/cart/update",
        "/cart/change",
        "/cart/clear",
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
        "/cart/add.js?upcart=1&opens_cart=maybe",
    ];

    function isShopifyCartURL(url) {
        if (url instanceof URL) url = url.href;
        if (typeof url == "object" && url.url) url = url.url;
        if (!url || url.includes("app=salepify")) return false;

        try {
            let path = url.split("/").pop();
            path = path.split("?").shift();
            return ShopifyCartURLs.includes(`/cart/${path}`);
        } catch (e) {
            console.log("Not a normal URL: ", e);
            return false;
        }
    }

    function updateType(url) {
        if (!url || url.includes("app=salepify")) return false;
        if (url.includes("cart/add")) {
            return "add";
        } else if (url.includes("cart/update")) {
            return "update";
        } else if (url.includes("cart/change")) {
            return "change";
        } else if (url.includes("cart/clear")) {
            return "clear";
        } else return false;
    }

    function dispatchEvent(url, detail) {
        if (typeof detail === "string") {
            try {
                detail = JSON.parse(detail);
            } catch (e) {
                console.log("Error: ", e);
            }
        }

        const type = updateType(url);
        switch (type) {
            case "add":
                window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
                break;
            case "update":
                window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
                break;
            case "clear":
                window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
                break;
            case "change":
                window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
                break;
            default:
                break;
        }
    }

    function getJsonBodyArgument(bodyArgument) {
        if (!bodyArgument) return {};

        let jsonBodyArgument = {};
        if (window.tlFreeGiftOffer.utils.isJson(bodyArgument)) {
            jsonBodyArgument = JSON.parse(bodyArgument);
        } else if (typeof bodyArgument === "string") {
            const params = new URLSearchParams(bodyArgument);
            const json = Object.fromEntries(params.entries());
            jsonBodyArgument = json;
        }
        return jsonBodyArgument;
    }

    // Handle Shop pay
    async function getOtherPayItemData(originalData, parsedBody) {
        const lineItemData = parsedBody.variables?.input?.lines?.[0];
        const merchandiseId = lineItemData?.merchandiseId;
        const itemId = merchandiseId.split("/").pop();
        const itemDataRes = await window.tlFreeGiftOffer.storefrontApi.getVariantData(itemId);
        const itemData = itemDataRes.data.node;

        const sellingPlanAllocation = originalData?.data?.result?.cart?.lines?.edges?.[0]?.node?.sellingPlanAllocation;
        return {
            id: itemId,
            price: parseFloat(itemData.price.amount) * window.tlFreeGiftOffer.currencyRate,
            quantity: lineItemData?.quantity ?? 1,
            productId: itemData.product.id.split("/").pop(),
            selling_plan: !!sellingPlanAllocation,
        };
    }

    function hasSpecificCountryCondition(rule) {
        if (rule.advanced_conditions) {
            const advancedCondition = JSON.parse(rule.advanced_conditions);
            if (advancedCondition.specific_country) {
                return true;
            }
        }

        return false;
    }

    async function processOtherPayGiftRules(originalData, parsedBody) {
        const giftLines = [];
        const discounts = [];
        const rules = window.tlFreeGiftOffer.rules;

        const currentItemsInCart = window.tlFreeGiftOffer.itemsInCart;
        const currentRuleIdMapGifts = window.tlFreeGiftOffer.ruleIdMapGifts;

        // fake itemsInOtherPay
        const itemsInOtherPayCart = new Map();
        const itemData = await getOtherPayItemData(originalData, parsedBody);
        itemsInOtherPayCart.set(itemData.id, itemData);

        // fake ruleIdMapGiftAddedByApp
        window.tlFreeGiftOffer.itemsInCart = itemsInOtherPayCart;
        window.tlFreeGiftOffer.ruleIdMapGifts = new Map();

        let shouldPushLocation = false;
        for (const rule of rules) {
            if (rule.auto_add_gift) {
                const { needToAdd, giftsToAdd } = await window.tlFreeGiftOffer.checkRuleCondition(rule);
                if (needToAdd) {
                    for (const item of giftsToAdd) {
                        const giftLine = {
                            merchandiseId: `gid://shopify/ProductVariant/${item.id}`,
                            quantity: item.quantity,
                            attributes: Object.entries(item.properties || {}).map(([key, value]) => ({
                                key,
                                value: String(value),
                            })),
                        };
                        giftLines.push(giftLine);
                    }
                    discounts.push(rule.name);
                }
            }

            if (hasSpecificCountryCondition(rule)) shouldPushLocation = true;
        }

        if (shouldPushLocation) {
            const { country, region } = await this.getIpInfo();

            if (!Array.isArray(parsedBody.variables.input.attributes)) {
                parsedBody.variables.input.attributes = [];
            }
            parsedBody.variables.input.attributes.push({
                key: window.tlFreeGiftOffer.constants.LOCATION_CART_ATTRIBUTE,
                value: `${country}-${region}`,
            });
        }

        parsedBody.variables.input.lines.push(...giftLines);
        parsedBody.variables.input.discountCodes = discounts;

        // Restore state before handling OtherPay
        window.tlFreeGiftOffer.itemsInCart = currentItemsInCart;
        window.tlFreeGiftOffer.ruleIdMapGifts = currentRuleIdMapGifts;

        return parsedBody;
    }

    // Override fetch
    function detectAddApi(config) {
        let itemId = null;
        let quantity = 1;
        let sellingPlan = null;

        if (config.body instanceof FormData && config.body.getAll("id")) {
            const hasItems = Array.from(config.body.keys()).some((key) => /^items\[\d+\]\[id\]$/.test(key));
            if (hasItems) {
                // Logic bundle: lấy tổng quantity từ items[x][quantity]
                const quantities = Array.from(config.body.entries())
                    .filter(([key]) => /^items\[\d+\]\[quantity\]$/.test(key))
                    .map(([_, value]) => Number(value));

                const variantIds = Array.from(config.body.entries())
                    .filter(([key]) => /^items\[\d+\]\[id\]$/.test(key))
                    .map(([_, value]) => value);

                itemId = variantIds[0]; // chỉ lấy 1 id cho bundle
                quantity = quantities.length ? quantities.reduce((a, b) => a + b, 0) : 1;
            } else if (config.body.getAll("id")) {
                // Logic cũ: fallback
                itemId = String(config.body.getAll("id"));
                quantity = Number(config.body.getAll("quantity")) ? Number(config.body.getAll("quantity")) : 1;
            }
            const sellingPlanData = config.body.getAll("selling_plan");
            sellingPlan = sellingPlanData && sellingPlanData[0] ? sellingPlanData[0] : null;
        } else {
            const allRequestBody = config.body.split("&");
            if (allRequestBody.length) {
                allRequestBody.map((param) => {
                    if (param) {
                        const paramArray = param.split("=");
                        if (paramArray.length > 1) {
                            if (paramArray[0] === "id") {
                                itemId = paramArray[1];
                            } else if (paramArray[0] === "quantity") {
                                quantity = paramArray[1] ? Number(paramArray[1]) : 1;
                            } else if (paramArray[0] === "selling_plan") {
                                sellingPlan = paramArray[1] ?? null;
                            }
                        } else if (window.tlFreeGiftOffer.utils.isJson(param)) {
                            const paramObj = JSON.parse(param);
                            if (paramObj.id) {
                                itemId = String(paramObj.id);
                                quantity = paramObj.quantity ? Number(paramObj.quantity) : 1;
                                sellingPlan = paramObj.selling_plan ?? null;
                            } else if (paramObj.items) {
                                // Fix for theme Beauty has body format {items:[{id,quantity}]}
                                const firstItem = paramObj.items[0];
                                let tmpQuantity = 0;
                                paramObj.items.forEach((item) => {
                                    if (item.id === firstItem.id) {
                                        tmpQuantity += item.quantity ? Number(item.quantity) : 1;
                                    }
                                });
                                quantity = tmpQuantity ? tmpQuantity : 1;
                                itemId = String(firstItem.id);
                                sellingPlan = firstItem.selling_plan ?? null;
                            }
                        }
                    }
                });
            }
        }

        return { itemId, diffQuantity: quantity, sellingPlan };
    }

    function detectChangeApi(config, cartDataRes) {
        let items = JSON.parse(JSON.stringify(cartDataRes.items));

        const bodyArgument = getJsonBodyArgument(config.body);
        let lineChangeIndex = null;
        let newLineQty = Number(bodyArgument.quantity);

        if (bodyArgument.line) {
            lineChangeIndex = Number(bodyArgument.line) - 1;
        } else if (bodyArgument.id) {
            items.forEach((item, index) => {
                if (item.key === bodyArgument.id) {
                    lineChangeIndex = index;
                }
            });
        } else if (bodyArgument.updates) {
            const updates = bodyArgument.updates;
            items.forEach((item, index) => {
                if (updates[item.key] != null && item.quantity !== Number(updates[item.key])) {
                    lineChangeIndex = index;
                    newLineQty = Number(updates[item.key]);
                }
                if (Object.keys(updates) && Object.keys(updates).length) {
                    if (item.id == Object.keys(updates)[0]) {
                        lineChangeIndex = index;
                        newLineQty = updates[`${item.id}`];
                    }
                }
            });

            // Fix for theme has updates body format [{{line_change}}, {{new_qty}}]
            if (lineChangeIndex == null && updates.length == 2) {
                lineChangeIndex = Number(updates[0]);
                newLineQty = Number(updates[1]);
            }
        }
        return { lineChangeIndex, newLineQty };
    }

    function detectFetchData(resource, config, cartDataRes) {
        let data = {
            itemId: null,
            lineChangeKey: null,
            diffQuantity: 1,
            isChangeCartLine: false,
            lineChangeIsGift: false,
            sellingPlan: null,
            preventChangeQuantity: false,
            itemChangeData: null,
        };
        if (resource.includes("add")) {
            data = { ...data, ...detectAddApi(config) };
        } else {
            const { lineChangeIndex, newLineQty } = detectChangeApi(config, cartDataRes);
            if (lineChangeIndex !== null) {
                const itemChangeData = cartDataRes.items[lineChangeIndex];
                const lineChangeIsGift = window.tlFreeGiftOffer.checkLineItemIsGift(itemChangeData);
                if (lineChangeIsGift && (itemChangeData.price == 0 || itemChangeData.total_discount > 0)) {
                    const rule = window.tlFreeGiftOffer.ruleIdMapData.get(lineChangeIsGift);
                    data.preventChangeQuantity = rule && rule.prevent_change_gift_qty;
                }

                data = {
                    ...data,
                    itemId: String(itemChangeData.id),
                    lineChangeKey: String(itemChangeData.key),
                    diffQuantity: newLineQty > 0 ? newLineQty - itemChangeData.quantity : -itemChangeData.quantity,
                    isChangeCartLine: true,
                    lineChangeIsGift,
                    itemChangeData,
                };
            }
        }
        return data;
    }

    async function updateDataToCheck(itemId, lineChangeKey, diffQuantity, sellingPlan, lineChangeIsGift) {
        if (lineChangeIsGift) {
            const giftsInCart = window.tlFreeGiftOffer.ruleIdMapGifts.get(lineChangeIsGift) ?? [];
            window.tlFreeGiftOffer.ruleIdMapGifts.set(lineChangeIsGift, [
                ...giftsInCart,
                {
                    id: itemId,
                    key: lineChangeKey,
                    quantity: diffQuantity,
                },
            ]);
        } else {
            const updateId = lineChangeKey ?? itemId;
            const itemData = window.tlFreeGiftOffer.itemsInCart.get(updateId);
            if (itemData) {
                window.tlFreeGiftOffer.itemsInCart.set(updateId, {
                    ...itemData,
                    quantity: Math.max(itemData.quantity + diffQuantity, 0),
                });
            } else {
                let variantData = await window.tlFreeGiftOffer.storefrontApi.getVariantData(itemId);
                if (variantData) {
                    variantData = variantData.node;

                    const productData = variantData.product;
                    const productId = window.tlFreeGiftOffer.utils.getNoneGlobalId(productData.id);
                    let price = parseFloat(variantData.price.amount) * window.tlFreeGiftOffer.currencyRate;

                    // Case: Item added has selling plan => get price with selling plan
                    if (sellingPlan && !isNaN(Number(sellingPlan))) {
                        const productHandle = productData.handle;
                        const productRes = await window.tlFreeGiftOffer.ajaxApi.getProductByHandle(productHandle);
                        const variantData = productRes.variants.find((variant) => String(variant.id) == itemId);
                        for (let i = 0; i < variantData.selling_plan_allocations.length; i++) {
                            const sellingPlanAllocation = variantData.selling_plan_allocations[i];
                            if (String(sellingPlanAllocation.selling_plan_id) == sellingPlan) {
                                price = sellingPlanAllocation.price / 100;
                                break;
                            }
                        }
                    } else {
                        sellingPlan = null;
                    }

                    window.tlFreeGiftOffer.itemsInCart.set(updateId, {
                        id: itemId,
                        price,
                        quantity: diffQuantity,
                        productId,
                        selling_plan: !!sellingPlan,
                    });
                }
            }
        }
    }

    async function updateOriginalFetch(config, itemId, lineChangeKey, diffQuantity, lineChangeIsGift) {
        const cartDataRes = await window.tlFreeGiftOffer.ajaxApi.cartGet();
        // Update new data to original fetch - cart/change
        const dataUpdate = { line: 0, quantity: 0 };

        // Body of new api cart/update.js
        const updates = {};
        // Get line item change in original fetch by item key OR variant id
        const currentItemChange = cartDataRes.items.find((item) => {
            const isSameKey = item.key === lineChangeKey;
            const isSameId = String(item.id) === itemId;
            const giftProperty = window.tlFreeGiftOffer.checkLineItemIsGift(item);
            const isGiftValid =
                (!giftProperty && !lineChangeIsGift) ||
                (lineChangeIsGift && giftProperty == lineChangeIsGift && (diffQuantity > 0 || item.quantity >= Math.abs(diffQuantity)));

            return isSameKey || (isSameId && isGiftValid);
        });

        const quantity = String(Math.max(diffQuantity + currentItemChange.quantity, 0));
        updates[currentItemChange.key] = quantity;

        // Check if the product quantity change is less than 0, then adjust the quantity of
        // products with variant IDs matching the changed line item to the correct amount.
        for (let i = 0; i < cartDataRes.items.length; i++) {
            const item = cartDataRes.items[i];
            if (quantity >= 0) break;

            if (item.id == itemId && !updates[item.key]) {
                quantity += item.quantity;
                updates[item.key] = quantity;
            }
        }

        const bodyArgument = getJsonBodyArgument(config.body);
        // Check if the original fetch does not have the attribute `{{updates}}` in the body.
        if (!bodyArgument.updates) {
            // This API will update the quantity in the cart, replacing the original fetch.
            // Because there will be cases that require updating multiple line items,
            // the original `fetch cart/change` can only update one line at a time.
            const updateRes = await window.tlFreeGiftOffer.ajaxApi.cartUpdate({ updates });

            if (updateRes.items.length) {
                if (bodyArgument.id) {
                    dataUpdate.id = updateRes.items[0].key;
                }
                dataUpdate.line = 1;
                dataUpdate.quantity = String(updateRes.items[0].quantity);
            }
        }

        return JSON.stringify({
            ...bodyArgument,
            updates: bodyArgument.updates ? updates : undefined,
            ...dataUpdate,
        });
    }

    function fetchOverride() {
        if (!window.fetch || typeof window.fetch !== "function") return;
        const originalFetch = window.fetch;
        window.fetch = async function () {
            const [resource, config] = [...arguments];

            // Shop Pay
            const headers = config?.headers || {};
            const isOtherCreateCart = headers["X-Start-Wallet-Checkout"] === "true" && ["ShopPay", "BuyItNow"].includes(headers["X-Wallet-Name"]);
            if (isOtherCreateCart) {
                try {
                    const parsedBody = JSON.parse(config.body);
                    const isCartCreate = parsedBody.query?.includes("mutation cartCreate") && Array.isArray(parsedBody.variables?.input?.lines);

                    if (!isCartCreate) {
                        return originalFetch.apply(this, arguments);
                    }
                    const originalResponse = await originalFetch.apply(this, arguments);
                    const cloneRes = originalResponse.clone();
                    const originalData = await cloneRes.json();

                    const newBody = await processOtherPayGiftRules(originalData, parsedBody);
                    config.body = JSON.stringify(newBody);
                } catch (error) {
                    console.error("Error injecting gift into OtherPay cartCreate:", error);
                }
                return originalFetch.apply(this, arguments);
            } else if (isShopifyCartURL(resource) && config && config.body && config.body !== "{}") {
                window.tlFreeGiftOffer.cartHasChanged = true;
                const cartDataRes = await window.tlFreeGiftOffer.ajaxApi.cartGet();
                const {
                    itemId,
                    diffQuantity,
                    lineChangeKey,
                    sellingPlan,
                    isChangeCartLine,
                    itemChangeData,
                    lineChangeIsGift,
                    preventChangeQuantity,
                } = detectFetchData(resource, config, cartDataRes);

                // Can not detect item id or key of line change, should return original fetch
                if (!itemId && !lineChangeKey) return originalFetch(...arguments);

                // Case: line change is gift and rule set prevent change quantity, should return error
                if (preventChangeQuantity && itemChangeData) {
                    const errMessage = `You can't add more ${itemChangeData.quantity} ${itemChangeData.title} to the cart.`;
                    return window.tlFreeGiftOffer.utils.createAjaxCartErrorResponse(422, errMessage);
                }

                // Update data to variable `itemsInCart` and `ruleIdMapGifts` to check rule conditions
                await updateDataToCheck(itemId, lineChangeKey, diffQuantity, sellingPlan, lineChangeIsGift);

                const { isUpdateCart } = await window.tlFreeGiftOffer.checkAllRule(itemId, true);

                // Case: Has updated cart when check rule conditions, should update body of original fetch
                if (isUpdateCart && isChangeCartLine) {
                    arguments[1].body = await updateOriginalFetch(config, itemId, lineChangeKey, diffQuantity, lineChangeIsGift);
                }
                const response = originalFetch.apply(this, arguments);

                response.then((res) => {
                    res.clone()
                        .json()
                        .then((data) => dispatchEvent(res.url, data));
                });
                return response;
            } else {
                return originalFetch(...arguments);
            }
        };
    }

    fetchOverride();
};

const intervalId = setInterval(() => {
    if (tlFreeGiftOffer) {
        clearInterval(intervalId);
        customTLFreeGiftOverride();
        console.log("✅ Customization done!");
    }
}, 50);

setTimeout(() => clearInterval(intervalId), 3000);
